import * as React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";

/**
 * Confirmation dialog for changing auto-renew on a Squarespace subscription.
 * Use in admin subscription detail when user clicks On/Off to change renewal.
 */
export default function AutoRenewConfirmDialog({
  open,
  onClose,
  onConfirm,
  value,
  loading = false,
}) {
  const label = value === true ? "On" : "Off";
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="auto-renew-confirm-dialog-title"
      aria-describedby="auto-renew-confirm-dialog-description"
    >
      <DialogTitle id="auto-renew-confirm-dialog-title">
        Change Auto Renew?
      </DialogTitle>
      <DialogContent>
        <Typography id="auto-renew-confirm-dialog-description">
          Are you sure you want to set auto-renew to {label}? This will update
          the subscription and sync to Squarespace.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="primary"
          variant="contained"
          disabled={loading}
          startIcon={
            loading ? (
              <CircularProgress size={16} color="inherit" />
            ) : null
          }
        >
          {loading ? "Updating…" : `Yes, change to ${label}`}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
